import { render } from "./Dropzone.vue?vue&type=template&id=73645dcb&scoped=true"
import script from "./Dropzone.vue?vue&type=script&lang=js"
export * from "./Dropzone.vue?vue&type=script&lang=js"

import "./Dropzone.vue?vue&type=style&index=0&id=73645dcb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73645dcb"],['__file',"src/components/Dropzone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73645dcb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73645dcb', __exports__)) {
    api.reload('73645dcb', __exports__)
  }
  
  module.hot.accept("./Dropzone.vue?vue&type=template&id=73645dcb&scoped=true", () => {
    api.rerender('73645dcb', render)
  })

}


export default __exports__